export default class AdminService {
    constructor($http, appConfig, $window) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    }
  
    listDefaultTexts(entityId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/admin/defaulttexts/list/${entityId}/`);
    }  

    updateDefaultTexts(entityId, defaultTexts) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/admin/defaulttexts/update/${entityId}/`, defaultTexts);
    }          

    getWebEnquiryLocations() {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/admin/webenquirylocations`);
    }
    
    listOpenEnquiries(reportCriteria) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/admin/listOpenEnquiries`, reportCriteria);
    } 

    closeOpenEnquiries(enquiryIds) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/admin/closeOpenEnquiries`, enquiryIds);
    }     
  }
  


// WEBPACK FOOTER //
// ./client/app/common/services/admin.service.js